import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars
import fieldPropTypes from './field';

const { arrayOf, bool, number, objectOf, oneOfType, shape, string } = PropTypes;

export const appStepParams = objectOf(oneOfType([string, bool]));

export const appStepType = oneOfType([
  shape({
    appID: string.isRequired,
    params: appStepParams
  })
]);

export default shape({
  appStep: appStepType,
  conditionCode: string,
  conditions: arrayOf(string),
  createdBy: string,
  description: string,
  displayName: string,
  fields: arrayOf(fieldPropTypes),
  isTerminal: bool,
  maximumDuration: string,
  previousSteps: arrayOf(string),
  priority: string,
  processID: string,
  processName: string,
  requiredPreviousSteps: arrayOf(string),
  role: shape({
    users: arrayOf(string),
    fields: arrayOf(string)
  }),
  roleID: string,
  stepName: string,
  stepNumber: number,
  teamName: string
});



// WEBPACK FOOTER //
// ./js/types/api/step.js